<template>
  <div>
    <b-modal
      id="modalEditStatusShipper"
      size="lg"
      title="Tipo de retiros"
      hide-footer
      centered>
        <div class="container custom-modal-content">
          <div class="col-md-12 my-2">
            <h4>Seller 23423 - Empresa Development</h4>
            <!-- Fila de switches -->
            <div class="d-flex flex-wrap gap-4 mt-2">
              <!-- Diarios -->
              <div class="d-flex flex-column align-items-start ml-2 mr-4">
                <label class="mb-1 label-switch">{{$t('Retiro diario')}}</label>
                <b-form-checkbox
                  class="custom-switch-success"
                  :disabled="loading.updateShipper"
                  :checked="form.active_normal"
                  switch
                  @change="onChangeStatusSwitch('normal')"
                  v-model="form.active_normal"> {{$t(switchData.normal.statusText)}}
                </b-form-checkbox>
              </div>

              <!-- Frecuentes -->
              <div class="d-flex flex-column align-items-start">
                <label class="mb-1 label-switch">{{$t('Retiro frecuente')}}</label>
                <b-form-checkbox
                  class="custom-switch-success"
                  :disabled="loading.updateShipper"
                  :checked="form.active_frequent"
                  switch
                  @change="onChangeStatusSwitch('frequent')"
                  v-model="form.active_frequent"> {{$t(switchData.frequent.statusText)}}
                </b-form-checkbox>
              </div>
            </div>

            <!-- Botón -->
            <div class="mt-3">
              <b-button @click="updateStatusShipper" class="push-right" variant="warning" :disabled="disabled.updateShipper">
                {{$t('Guardar cambios')}}
                <feather-icon v-if="!loading.updateShipper" icon="SaveIcon"/>
                <i v-else :class="['fa', 'fa-spinner', 'fa-spin']"/>
              </b-button>
            </div>
          </div>
        </div>
    </b-modal>
  </div>
</template>

<script>
export default {
  props: ['selectedShipperStates'],
  data () {
    return {
      loading: {
        updateShipper: false
      },
      disabled: {
        updateShipper: true
      },
      changedSwitch : {
        normal: false,
        frequent: false
      },
      switchData: {
        normal: {
          statusText: 'Inhabilitado',
          acive: false
        },
        frequent: {
          statusText: 'Inhabilitado',
          acive: false
        }
      },
      form: {},
      originalShipperStates: null
    }
  },

  watch: {
    selectedShipperStates: {
      handler(newVal) {
        if (newVal && typeof newVal === 'object') {
          this.originalShipperStates = { ...newVal }
          this.form.active_normal = !newVal.shipper_normal_status
          this.form.active_frequent = !newVal.shipper_frequent_status

          this.switchData.normal.statusText = !newVal.shipper_normal_status ? 'Habilitado' : 'Inhabilitado'
          this.switchData.frequent.statusText = !newVal.shipper_frequent_status ? 'Habilitado' : 'Inhabilitado'
        }
      },
      deep: true
    }
  },
  methods: {
    updateStatusShipper() {
      const emitPayload = {
        shipper_normal_status: !this.form.active_normal,
        shipper_frequent_status: !this.form.active_frequent,
        shipper_id: [this.selectedShipperStates.id],
        changed_switch: {
          normal: this.changedSwitch.normal,
          frequent: this.changedSwitch.frequent
        }
      }
      this.$emit('confirmEditStateShipper', emitPayload)
    },
    onChangeStatusSwitch(type) {
      if (type === 'normal') {
        this.switchData.normal.statusText = this.form.active_normal ? 'Habilitado' : 'Inhabilitado'
      } else if (type === 'frequent') {
        this.switchData.frequent.statusText = this.form.active_frequent ? 'Habilitado' : 'Inhabilitado'
      }

      const { shipper_normal_status, shipper_frequent_status } = this.originalShipperStates
      const { active_normal, active_frequent } = this.form

      this.changedSwitch.normal = active_normal !== !shipper_normal_status
      this.changedSwitch.frequent = active_frequent !== !shipper_frequent_status

      this.disabled.updateShipper = !(this.changedSwitch.normal || this.changedSwitch.frequent)
    }
  }
}
</script>

<style lang="scss">
.custom-modal-content {
  max-height: 70vh;
  overflow-y: auto;
}
.label-switch {
  font-size: 1.25rem;
  font-weight: 500;
}
.custom-switch-success {
  margin-top: 0.5rem;
  .custom-control-label {
    font-size: 14px !important;
  }
  .custom-control-input:checked ~ .custom-control-label::before {
    background-color: #28a745 !important;
    border-color: #28a745 !important;
  }
  .custom-control-input:focus ~ .custom-control-label::before {
    box-shadow: none !important;
  }
  .custom-control-input:active ~ .custom-control-label::before {
    background-color: #28a745 !important;
    border-color: #28a745 !important;
  }
}
</style>